module.exports = __webpack_public_path__ + "img/coctail_de_camaron.bc8285e4.jpg";